import React, { memo } from 'react';
import { Wallet } from '@mercadopago/sdk-react';

const CheckoutProButton = memo(({ preferenceId }) => {
	return (
		<div>
			<Wallet initialization={{ preferenceId: preferenceId }} />
		</div>
	);
});

CheckoutProButton.displayName = 'CheckoutProButton';

export default CheckoutProButton;
